import React from "react";

import { Icon } from "../IconExporter";
import { Container, Separator } from "./styles";

type BreadcrumbsProps = {
  items: string[];
  selected: string;
  handleClickFixedItem: () => void;
  handleClick: (value: string) => void;
};

export const Breadcrumbs = ({
  items = [],
  selected,
  handleClick,
  handleClickFixedItem,
}: BreadcrumbsProps) => {
  const handleLocalClick = (item) => () => handleClick(item);
  return (
    <Container>
      <Icon name="dashboard" handleClick={handleClickFixedItem} />
      <Separator />
      {items &&
        items.map((item) => (
          <div
            className={
              selected === item ? "selected itemContainer" : "itemContainer"
            }
            key={item}
            onClick={handleLocalClick(item)}
          >
            <p>{item}</p>
          </div>
        ))}
    </Container>
  );
};
